import { render, staticRenderFns } from "./FirmaKayit.vue?vue&type=template&id=9116089c&scoped=true&"
import script from "./FirmaKayit.vue?vue&type=script&lang=js&"
export * from "./FirmaKayit.vue?vue&type=script&lang=js&"
import style0 from "./FirmaKayit.vue?vue&type=style&index=0&id=9116089c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9116089c",
  null
  
)

export default component.exports